<template>
	<div>
		<Header :sel='type' @changePhone="changePhone" />
		<div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">

			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner18.png">
				<div class="nybt">
					<h3>科研创新</h3>
				</div>
			</div>

			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					<a href="/#/societyOneList?type=100006&title=科研创新">科研创新</a> {{ title ? ('>' + title) : '' }}
				</div>
			</div>

			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">
					<!-- * 左侧 * -->
					<div class="page-wrap-left xymob-menu-click visible-xs visible-sm">
						<div class="xymob-left-close-btn"><i class="icon-font icon-close"></i></div>
						<div class="xypg-left">
							<!-- * 分类 * -->






						</div>
					</div>

					<!-- * 右侧 * -->
					<div class="page-wrap-right">
						<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
							<div>
								<ul class="xypg-left-nav">
									<li :class="item.categoryCode == type ? 'clicked' : ''" v-for="item in actList">
										<a href="javascript:void(0)"
											@click="changeData(item.categoryCode, item.categoryName, item.url)">
											{{ item.categoryName }}</a>
										<div class="first-nav-btn"></div>
									</li>
								</ul>
							</div>
						</div>

						<div class="xypg-right-content">

							<!-- 产品列表页 -->
							<!-- 	<ul class="xypg-product-list clearfix">
									<li v-for="item in list" @click="goDetail(item.id)">
										<a href="javascript:void(0)" class="img"><img
												:src="item.image" /></a>
										<h3><a href="javascript:void(0)">{{item.title}}</a></h3>
									</li>
								</ul> -->
							<ul class="chuangxin_list">
								<li v-for="(item, index) in list" @click="goDetail(item.id)">
									<template v-if="index % 2 === 0">
										<div class="chuangxin_img"><img :src="item.image" /></div>
										<div class="chuangxin_txt">
											<div class="chuangxin_num">{{ (index + 1).toString().padStart(2, '0') }}</div>
											<div class="chuangxin_t">{{ item.title }}</div>
											<div class="chuangxin_c">{{ item.describtion }}</div>
										</div>
									</template>
									<template v-else>
										<div class="chuangxin_txt">
											<div class="chuangxin_num">{{ (index + 1).toString().padStart(2, '0') }}</div>
											<div class="chuangxin_t">{{ item.title }}</div>
											<div class="chuangxin_c">{{ item.describtion }}</div>
										</div>
										<div class="chuangxin_img"><img :src="item.image" /></div>
									</template>


								</li>
							</ul>
							<!-- 		<div class="xypg-pagination">
									<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
										:current-page="pageNum" :page-sizes="[12, 24, 48, 96]"
										:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
										:total="total">
									</el-pagination>
								</div> -->
						</div>
					</div>
				</div>

				<!-- * 手机弹窗 * -->

			</div>
		</div>

		<Footer></Footer>

	</div>


</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import {
	articleList,
	categorysortPage
} from '@/api/reqFetch.js'
export default {
	name: '',
	layout: '',
	components: {
		Footer,
		Header
	},
	data() {
		return {
			tabList: [],
			selName: '',
			selid: '0',
			list: [],
			pageNum: 1,
			indexs: [],
			showPhone: false,
			type: '',
			categoryCode: '',
			configList: [],
			selOneName: '',
			title: '',
			total: 0,
			pageSize: 12,
			actList: [],

		}
	},

	mounted() {
		this.type = this.$route.query.type
		this.title = this.$route.query.title
		this.getData()
		this.getCategorysortPage()

	},

	methods: {
		getCategorysortPage() {
			categorysortPage({
				pos: 'top'
			}).then(res => {
				res.data.map(item => {
					if (item.categoryName == '科研创新') {
						this.actList = item.children
						this.actList.sort((a, b) => a.orderNum - b.orderNum);
					}
				})

			});
		},
		changeData(id, title, href) {
			if (title == '创新平台') {
				let url = '/society?type=' + id + '&title=' + title
				this.$router.push(url)
				this.$router.go(0)
			} else {
				this.$router.push({
					path: href+'&type='+id+'&title='+title
				})
			}

		},

		goDetail(id) {
			this.$router.push({
				path: 'societyDetail?id=' + id,
			})
		},


		// 页码容量变化
		handleSizeChange(pageSize) {
			this.pageNum = 1
			this.pageSize = pageSize
			this.getData()
		},

		// 当前页码变化
		handleCurrentChange(pageNum) {
			this.pageNum = pageNum
			this.getData()
		},
		changePhone(val) {
			this.showPhone = val
		},


		getData() {
			let par = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				status: 1,
				categoryCode: this.type
			}
			articleList(par).then(res => {
				this.list = res.rows;
				this.total = res.total

			});
		},

	}
}
</script>

<style scoped>
.page-wrap,
.page-position {
	background-color: #f1f5f8;
}

.logo-img {
	width: 180px;
	height: 55px;
	flex-shrink: 0
}

ul.chuangxin_list {
	width: 1200px;
	margin: 0 auto;
}

ul.chuangxin_list li {
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
}

.chuangxin_img {
	width: 50%;
}

.chuangxin_img img {
	width: 100%;
}

.chuangxin_txt {
	width: 50%;
	padding: 5%;
	background-color: #fff;
	transition: background-color 0.3s ease, padding 0.3s ease, box-shadow 0.3s ease;
}

.chuangxin_num {
	color: #0074b1;
	font-size: 84px;
	line-height: 90px;
}

.chuangxin_txt:hover {
	color: #fff;
	background: #0074b1;
}

.chuangxin_txt:hover>.chuangxin_num {
	color: #fff;
}

.chuangxin_t {
	font-size: 32px;
}

@media (max-width: 768px) {
	ul.chuangxin_list {
		width: 100%;
	}

	.chuangxin_img {
		width: 100%;
	}

	.chuangxin_txt {
		width: 100%;
	}

	.chuangxin_num {

		font-size: 54px;

	}

	.chuangxin_t {
		font-size: 20px;
	}
}
</style>